import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateCampaignList } from '../../../redux/actions/CampaignListsActions';
import NavigationComponent from "../../commonComponents/util/NavigationComponent";
import EditCampaignListModal from './EditCampaignListModal';
import { PermissionTypes } from '../../../lib/systemVariables';
import { formatDate } from '../../../lib/utils';

const initialState = {
    showModals: {
        editCampaignListModal: false
    }
};

class CampaignListInfo extends NavigationComponent {
    constructor(props) {
        super(props);

        this.state = initialState;
    }

    render() {
        const campaignList = this.props.campaignList;
        const locationGroup = campaignList.locationId ?
            this.props.locationGroups[this.props.locationGroups.map(loc => loc.groupId.toString()).indexOf(campaignList.locationId.toString())] : null;
        return (
            <div>
                <div>
                    <h2 className="page-header">
                        {campaignList.name}
                        {campaignList.batch && <i className="material-icons ml-16 large-text">filter_none</i>}
                        {this.props.userPermissions.manage &&
                        <span className="btn btn-primary btn-small icon-right" onClick={this.toggleModal.bind(this, "editCampaignListModal")}>Edit</span>}
                    </h2>
                    <div className="flex campaign-header-icons">
                        <p className="small-text"><i className="icon-home icon-left accent-text2"></i>{campaignList.fundName}</p>
                        {locationGroup && locationGroup.members.length > 0 &&
                        <p className="small-text"><i className="icon-location-pin icon-left accent-text2"></i>
                            {locationGroup.members.map(loc => loc.city).join(', ') || locationGroup.members[0].country} </p>}
                        {campaignList.allowDuplicates && <p className="small-text"><i className="icon-check icon-left accent-text2" />Duplicates Enabled</p>}
                        {campaignList.managerName && <p className="small-text"><i className="icon-user icon-left accent-text2" />Manager: {campaignList.managerName}</p>}
                        {campaignList.managerEmail && <p className="small-text"><i className="icon-envelope icon-left accent-text2" />{campaignList.managerEmail}</p>}
                        <p className="small-text"><i className="icon-pencil icon-left accent-text2" />Created by {campaignList.createdBy} on {formatDate(campaignList.createdOn)}</p>
                        {campaignList.updatedOn && <p className="small-text"><i className="icon-refresh icon-left accent-text2" />Updated by {campaignList.updatedBy} on {formatDate(campaignList.updatedOn)}</p>}
                    </div>
                </div>
                
                <EditCampaignListModal
                    show={this.state.showModals.editCampaignListModal}
                    close={this.toggleModal.bind(this, "editCampaignListModal")}
                    {...this.props.updateCampaignList}
                    isAdmin={this.props.userPermissions.admin}
                    campaignList={campaignList}
                    locations={this.props.locationGroups}
                    ILFunds={this.props.funds.IL || []}
                    USFunds={this.props.funds.US || []}
                    updateCampaignList={this.props.actions.updateCampaignList}/>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
      ...state.campaignListDetails,
      locationGroups: state.settings.systemSettings.data.campaignSettings.locationGroups.filter(lg =>
        state.userProfile.profile.data.departments.indexOf(lg.department) >= 0),
      funds: state.funds.fundsByDept,
      userPermissions: {
        admin: state.userProfile.profile.data.roleId === 1,
        manage: state.userProfile.permissions.data.indexOf(PermissionTypes.CampaignAndListsManage) >= 0
      }
    }
  }

function mapDispatchToProps(dispatch) {
    return {
      actions: bindActionCreators({ updateCampaignList }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CampaignListInfo);




// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignListDetails/CampaignListInfo.jsx